import { render, staticRenderFns } from "./PersonalityResults.vue?vue&type=template&id=bd76c98e&scoped=true"
import script from "./PersonalityResults.vue?vue&type=script&lang=js"
export * from "./PersonalityResults.vue?vue&type=script&lang=js"
import style0 from "./PersonalityResults.vue?vue&type=style&index=0&id=bd76c98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd76c98e",
  null
  
)

export default component.exports